import Vue from 'vue'
import svgIcon from '@/components/svgIcon'

// register globally
Vue.component('svg-icon', svgIcon)

const requireAll = requireContext => requireContext.keys().map(requireContext)
const req = require.context('./', true, /\.svg$/)
requireAll(req)



// WEBPACK FOOTER //
// ./src/assets/svg/index.js